/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function documentReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}


function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}


documentReady(function() { 
    waitForElm('.cf-react-target')
      .then((cf_form) => {
          
        const observer = new MutationObserver(mutations => {
          const evt = new CustomEvent('cf-changed', {detail: mutations});
          document.body.dispatchEvent(evt);
        });

        observer.observe(cf_form, {
            childList: true,
            subtree: true,
            characterData: true
        });
        
      })
      .catch((err) => console.error(err));
});

document.body.addEventListener('cf-changed', e => {
  const mutation = e.detail[0];
  if( mutation.removedNodes.length>0 && mutation.removedNodes[0].classList ) { //&& mutation.removedNodes[0].classList)  && mutation.removedNodes[0].classList.contains('cf-submit-form')) {
    if( mutation.removedNodes[0].className == 'cf-form-step' ) {
     window.scrollTo(0, 0);
    }
  }
});


document.addEventListener('modal:closed', function(event) {
  const id = event.detail.id;
  if(id === 'modal-shipto-change') {
      location.reload();
  }    
});

// Subscription cart mutations
const isValidCartLocal = (exciseRegion) => {
    const miniCartItems = document.querySelectorAll('.mini-cart__price-list');
    let validCart = true;
    // miniCartItems.forEach(item => { validCart = validCart && (item.getAttribute('data-excise-region') == exciseRegion); });
    return validCart;
}

const isValidCartFetch = async() => {
    fetch('/cart.js', {
        method:'GET'
    })
    .then(response => {
        const resp = response.json();
        let refCode = '';
        resp.items.forEach((item, index) => {
            const stateCode = item.properties['Unit Excise Tax'].split(' State: ')[0];
            if(index==0) {refCode = stateCode}
            else if(refCode !== stateCode) {
                return false;
            }
        });
        return true;
    })
    .catch(error => {
        console.error('Error:', error)
        return false;
    });
}

//  document.addEventListener('product:added', function(event) {
//    // const currState = event.detail.stateCode;
//    const exciseRegion = event.detail.exciseRegion;
//    if(!isValidCartLocal(exciseRegion)) {
//         fetch('/cart/clear.js', {
//             method: 'POST',
//         })
//         .then(response => {
//             document.querySelector('#modal-shipto-change-trigger').click();        
//         })
//         .catch((error) => {
//             console.error('Error:', error);
//         });
//    }
//  });

document.addEventListener('cart:change:rerendered', function(event) {
    let line = event.detail.line; // Get the variant that was added
    let quantity = event.detail.quantity; // Get the quantity that was added

    if(event.detail.variant) { // product add
        const variant = event.detail.variant;
        const quantity = event.detail.quantity;
        const targetButton = document.querySelector('.a2c_dyn_button[data-variant-id="'+(variant.id ? variant.id : variant)+'"]');

        if(targetButton) {

            targetButton.querySelector('.add2cart_ui').style.display = "none";
            targetButton.querySelector('.cart_quantity_ui').style.display = "inline-flex";
            targetButton.querySelector('.cart__remove').setAttribute('data-line', line);
            targetButton.querySelector('.cart__remove').style.display = 'inline-block';
            targetButton.querySelector('.cart__remove').setAttribute('href', '/cart/change?quantity=0&line='+line);

            const quantityButtonsAll = document.querySelectorAll('.quantity-selector__button, .quantity-selector__value');
            quantityButtonsAll.forEach(function(btn){
                if(btn.closest(".a2c_dyn_button")==targetButton) {
                    btn.setAttribute('data-line', line);
                    btn.setAttribute('data-quantity', parseInt(btn.getAttribute('data-quantity'))+quantity);
                } else {
                    const newDataLineNum = btn.getAttribute('data-line') !== "0" ? parseInt(btn.getAttribute('data-line')) + 1 :  0;
                    btn.setAttribute('data-line', newDataLineNum);
                }
                //btn.setAttribute('data-quantity', parseInt(btn.getAttribute('data-quantity'))+quantity);
            });

            const removeLinkAll = document.querySelectorAll('.cart__remove');
            removeLinkAll.forEach(function(link){
                if(link.closest(".a2c_dyn_button")!==targetButton) {
                    const newDataLineNum = link.getAttribute('data-line') !== "0" ? parseInt(link.getAttribute('data-line')) + 1 :  0;
                    link.setAttribute('data-line', newDataLineNum);
                    link.setAttribute('href', '/cart/change?quantity=0&line='+newDataLineNum);
                }
            });

            const quantitySelector = targetButton.querySelector('.quantity-selector__value');
            quantitySelector.value = quantity;
            quantitySelector.setAttribute('data-current-value', quantity);

        }
    }
    else if(parseInt(quantity)==0) {  // product delete 
        const targetButton = document.querySelector('.a2c_dyn_button a.cart__remove[data-line="'+line+'"]');
        targetButton.parentNode.parentNode.querySelector('.add2cart_ui').style.display = 'block';
        targetButton.parentNode.parentNode.querySelector('.cart__remove').style.display = 'none';
        
        const quantitySelector = document.querySelector('.a2c_dyn_button input.quantity-selector__value[data-line="'+line+'"]');
        const quantitySelectorDown = document.querySelector('.a2c_dyn_button button.quantity-selector__button[data-line="'+line+'"][data-action="decrease-quantity"]');
        const quantitySelectorUp = document.querySelector('.a2c_dyn_button button.quantity-selector__button[data-line="'+line+'"][data-action="increase-quantity"]');

        quantitySelector.value = 1;
        quantitySelectorDown.setAttribute('data-quantity', -1);
        quantitySelectorUp.setAttribute('data-quantity', 1);

        const quantityButtonsAll = document.querySelectorAll('.quantity-selector__button, .quantity-selector__value');
        quantityButtonsAll.forEach(function(btn){
            if(btn.closest(".a2c_dyn_button")==targetButton) {
                btn.setAttribute('data-line', line);
                btn.setAttribute('data-quantity', parseInt(btn.getAttribute('data-quantity'))+quantity);
            } else {
                const currDataLineNum = btn.getAttribute('data-line');
                const newDataLineNum = currDataLineNum > line ? parseInt(currDataLineNum) - 1 :  currDataLineNum;
                btn.setAttribute('data-line', newDataLineNum);
            }
        });

        const removeLinkAll = document.querySelectorAll('.cart__remove');
            removeLinkAll.forEach(function(link){
                if(link.closest(".a2c_dyn_button")!==targetButton) {
                    const currDataLineNum = link.getAttribute('data-line');
                    const newDataLineNum = currDataLineNum > line ? parseInt(currDataLineNum) - 1 : currDataLineNum;
                    link.setAttribute('data-line', newDataLineNum);
                    link.setAttribute('href', '/cart/change?quantity=0&line='+newDataLineNum);
                }
            });

    } else { // product update quantity
        const quantitySelector = document.querySelector('.a2c_dyn_button input.quantity-selector__value[data-line="'+line+'"]');

        quantitySelector.value = quantity;
        quantitySelector.setAttribute('data-current-value',quantity);

        const quantitySelectorDown = document.querySelector('.a2c_dyn_button button.quantity-selector__button[data-line="'+line+'"][data-action="decrease-quantity"]');
        const quantitySelectorUp = document.querySelector('.a2c_dyn_button button.quantity-selector__button[data-line="'+line+'"][data-action="increase-quantity"]');

        quantitySelectorDown.setAttribute('data-quantity',quantity-1);
        quantitySelectorUp.setAttribute('data-quantity',quantity+1);
    }
});

document.addEventListener("DOMContentLoaded", function() {

    // const createCustomerButton = document.querySelector('#create_customer button.cf-submit-form');
    // if(createCustomerButton) {
    //   createCustomerButton.addEventListener('click', e => {
    //     window.scrollTo(0, 0);
    //     //setTimeout(() => { window.scrollTo(0, 0) }, 1500);
    //   });
    // }

    // const checkOutButton = document.querySelector('.button[name="checkout"]');
    // if(checkOutButton) {
    //     checkOutButton.form.addEventListener('submit', e => {
    //         // const currState = document.querySelector('.header__action-item--address .shipto-link').getAttribute('data-shipto-state');
    //         const exciseRegion = document.querySelector('.header__action-item--address .shipto-link').getAttribute('data-excise-region');
    //         if(!isValidCartLocal(exciseRegion)) {
    //             fetch('/cart/clear.js', {
    //                 method: 'POST',
    //             })
    //             .then(response => {
    //                 document.querySelector('#modal-shipto-change-trigger').click();        
    //             })
    //             .catch((error) => {
    //                 console.error('Error:', error);
    //             });
    //             return false;
    //         } 
    //     });
    // }

    const modal__cartDisabled = document.querySelector('#modal__cartDisabled-disabled-cart');
    document.querySelectorAll('.super-button.cart-disabled').forEach(item => {
        item.addEventListener('click', event => {
            if (modal__cartDisabled) {
                var onOpen = function onOpen(event) {
                  if (event.propertyName === 'visibility') {
                    modal__cartDisabled.removeEventListener('transitionend', onOpen);
                    Accessibility.trapFocus(modal__cartDisabled, 'modal__cartDisabled' + modal__cartDisabled.id);
      
                    _this.activemodal__cartDisabledsQueue.push(modal__cartDisabled);
                  }
                };
      
                modal__cartDisabled.addEventListener('transitionend', onOpen);
                modal__cartDisabled.setAttribute('aria-hidden', 'false');
                document.documentElement.classList.add('is-locked');
                const domDelegate = new Delegate(document.body);
                domDelegate.on('click', this._clickOutsideListener);
                domDelegate.on('keyup', this._onKeyPressedListener);
                return false; // Prevent the event to be propagated to the clickOutsideListener immediately
              }
        });
    });

    const logoutLink = document.querySelector('.popover__link-item.logout');
    if(logoutLink) {
        logoutLink.addEventListener('click', event => {
            event.preventDefault();
            fetch('/cart/clear.js', {
                method: 'POST',
              })
              .then(response => {
                  
                window.localStorage.removeItem('isLoggedIn');
    
                window.location.href =  event.target.href;
                return response.json();
                
              })
              .catch((error) => {
                console.error('Error:', error);
              });
            
        });
    }
    

    const chooseShipToLinks = document.querySelectorAll('.address-list__action-list .choose-shipto');
    if(chooseShipToLinks) {
        chooseShipToLinks.forEach(chooseShipToLink => {
            chooseShipToLink.addEventListener('click', event => {
                event.preventDefault();
                const oldShipToRegion = document.querySelector('.header__action-item--address .shipto-link').getAttribute('data-excise-region');
                const newShipToRegion = event.target.getAttribute('data-excise-region');
                if(oldShipToRegion!==newShipToRegion) {
                    document.querySelector('#confirm-change-state-trigger').click();
                    document.querySelector('#confirm-change-state').addEventListener('click', (evt) => {
                        fetch('/cart/clear.js', {
                            method: 'POST',
                        })
                        .then(response => {
                            event.target.form.submit();
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                    });

                } else {
                    
                    const oldShipToLicenseType = document.querySelector('.header__action-item--address .shipto-link').getAttribute('data-license-type');;
                    const newShipToLicenseType = event.target.getAttribute('data-license-type');
                    if(oldShipToLicenseType!==newShipToLicenseType) {
                        document.querySelector('#confirm-change-license-trigger').click();
                        document.querySelector('#confirm-change-license').addEventListener('click', (evt) => {
                            fetch('/cart/clear.js', {
                                method: 'POST',
                            })
                            .then(response => {
                                event.target.form.submit();
                            })
                            .catch((error) => {
                                console.error('Error:', error);
                            });
                        });
    
                    } else {
                    
                        event.target.form.submit();

                    }
                }
            });
        })
    }
});